import React from "react";

const HomePageOne = React.lazy(() => import("./pages/HomePageOne"));
const ProductDetailsPageOne = React.lazy(() =>
  import("./pages/ProductDetailsPageOne")
);

const CartPage = React.lazy(() => import("./pages/CartPage"));
const CheckoutPage = React.lazy(() => import("./pages/CheckoutPage"));

const CategoryPage = React.lazy(() => import("./pages/CategoryPage"));
const ProductPage = React.lazy(() => import("./pages/ProductPage"));

const ContactPage = React.lazy(() => import("./pages/ContactPage"));
const SignIn = React.lazy(() => import("./pages/auth/SignIn"));
const SignInOtpPage = React.lazy(() => import("./pages/auth/SignInOtpPage"));
const SignUp = React.lazy(() => import("./pages/auth/SignUp"));
const SignUpOtpPage = React.lazy(() => import("./pages/auth/SignUpOtpPage"));

const Dashboard = React.lazy(() => import("./pages/profile/Dashboard"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const ReturnsPolicy = React.lazy(() => import("./pages/ReturnsPolicy"));
const TermsConditions = React.lazy(() => import("./pages/TermsConditions"));
const ShippingPolicy = React.lazy(() => import("./pages/ShippingPolicy"));
const RefundPolicy = React.lazy(() => import("./pages/RefundPolicy"));
const PolicyAntiPhishingAlert = React.lazy(() => import("./pages/PolicyAntiPhishingAlert"));

const Faqs = React.lazy(() => import("./pages/Faqs"));
const AccountDeletionInstruction = React.lazy(() =>
  import("./pages/AccountDeletionInstruction")
);
const VerifyOtp = React.lazy(() => import("./pages/auth/VerifyOtp"));
const OrderSuccess = React.lazy(() => import("./pages/OrderSuccess"));
const IndexPolicy = React.lazy(() => import("./pages/legalpolicy/IndexPolicy"));
const OrderList = React.lazy(() => import("./pages/OrderList"));
const OrderDetails = React.lazy(() => import("./pages/OrderDetails"));
const AboutPage = React.lazy(() => import("./pages/About"));


const routes = [
  { path: "/", exact: true, name: "Home", component: HomePageOne },
  {
    path: "/product-details/:slug",
    exact: false,
    name: "Product Details One",
    component: ProductDetailsPageOne
  },

  { path: "/cart", exact: true, name: "Cart", component: CartPage },
  { path: "/category", exact: true, name: "Checkout", component: CategoryPage },
  { path: "/product", exact: true, name: "Product", component: ProductPage },

  { path: "/contact", exact: true, name: "Contact", component: ContactPage },

    { path: "/about", exact: true, name: "AboutUs", component: AboutPage },


  { path: "/sign-in", exact: true, name: "Sign In", component: SignIn },
  {
    path: "/sign-in-otp-page",
    exact: true,
    name: "Verify OTP",
    component: SignInOtpPage
  },

  {
    path: "/sign-up",
    exact: true,
    name: "Sign Up",
    component: SignUp
  },
  {
    path: "/sign-up-otp-page",
    exact: true,
    name: "Sign Up",
    component: SignUpOtpPage
  },

  {
    path: "/privacy-policy",
    exact: true,
    name: "Privacy Policy",
    component: PrivacyPolicy
  },
  {
    path: "/returns-policy",
    exact: true,
    name: "Returns Policy",
    component: ReturnsPolicy
  },
  {
    path: "/terms-conditions",
    exact: true,
    name: "Terms and Conditions",
    component: TermsConditions
  },
  {
    path: "/shipping-policy",
    exact: true,
    name: "Shipping Policy",
    component: ShippingPolicy
  },
  {
    path: "/refund-policy",
    exact: true,
    name: "Refund Policy",
    component: RefundPolicy
  },
  {
    path: "/anti-phishing-alert",
    exact: true,
    name: "Anti Phishing Alert",
    component: PolicyAntiPhishingAlert
  },
  {
    path: "/faqs",
    exact: true,
    name: "Faqs",
    component: Faqs
  },
  {
    path: "/account-deletion-instruction",
    exact: true,
    name: "Account Deletion Instruction",
    component: AccountDeletionInstruction
  },
  {
    path: "/verify-otp",
    exact: true,
    name: "Verify OTP",
    component: VerifyOtp
  },
  {
    path: "/legal-policy",
    exact: true,
    name: "Refund Policy",
    component: IndexPolicy
  }
];

const privateRoutes = [
  { path: "/checkout", exact: true, name: "Checkout", component: CheckoutPage },

  {
    path: "/dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/order-success",
    exact: true,
    name: "Order Success",
    component: OrderSuccess
  },
  { path: "/order-list", exact: true, name: "OrderList", component: OrderList },
  {
    path: "/order/:orderId/:productId",
    exact: true,
    component: OrderDetails
  },
  {
    path: "/order/:orderId/:productId?/:variationId?",
    exact: true,
    name: "OrderDetails",
    component: OrderDetails
  },
];

export default { routes, privateRoutes };
